/**
 * Copyright Highway9 Networks Inc.
 */
import APIService from "./APIServices";
import { RawDraftContentState } from "react-draft-wysiwyg";
type NotesData = {
  objectId: string;
  note: RawDraftContentState;
};
const NotesAPI = new APIService<NotesData>('notes');

export const notesService = {
  getNotes,
  modifyNotes,
};

async function getNotes(id : string) {
  const notes = await NotesAPI.get(id) as NotesData[];
  return notes[0].note;
}

async function modifyNotes(notes: NotesData) {
  return await NotesAPI.update(notes, notes.objectId);
}
